import { FC } from 'react'

export const Twitter: FC<{ isShare?: boolean }> = ({ isShare }) => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={isShare ? 'url(#golden-texture)' : 'currentColor'}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46538 2.54372C4.57799 4.65106 1.29562 9.70291 1.29562 14.9424C1.29562 20.254 4.47677 25.3059 9.36417 27.4421C14.7432 29.8093 20.8163 28.5246 24.6047 24.7574C32.9191 16.4579 27.8293 1.82203 15.177 1.37458C13.0948 1.30241 11.0849 1.83646 9.46538 2.54372ZM3.26215 5.67587C5.96612 2.31278 8.64118 1.12921 12.7767 0.176573C14.6854 -0.256442 17.8376 0.176573 19.5438 0.725059C29.8103 3.97267 33.136 16.5445 26.7303 24.3821C20.9898 31.4114 10.6222 31.7723 4.63583 25.8688C-0.902262 20.4128 -1.62525 11.7525 3.26215 5.67587ZM21.5011 8.06452L16.3321 13.9406L21.9355 21.9355H17.8089L14.0299 16.5538L9.29524 21.9355H8.06452L13.4797 15.7769L8.06452 8.06452H12.2055L15.7819 13.1637L20.2704 8.06452H21.5011ZM11.6264 8.96853H9.74409L18.4026 21.0738H20.2849L11.6264 8.96853Z"
      />
    </g>
  </svg>
)
